const $ = require('./sukoa-jquery.cjs');
import Swiper from 'swiper';
const sukoaUtils = require('./sukoaUtils').default;
import Lazy from './Lazy';
const animation = require('./headerAnimation').default;
const navigation = require('./navigation').default;
const blog = require('./blog').default;
const projects = require('./projects/listView').default;
const expertises = require('./expertises/expertises').default;
import initProjectContent from './projects/ProjectContent.js'

const app = {

    init: function () {
        $('html').removeClass('no-js');
        if($("body#home, body#project").size()>0) {
            $("body,html").animate({scrollTop: 0}, 0);
        }

        app.lazy();
        animation.init();

        navigation.init($);
        blog.commentInteraction($, sukoaUtils);
        projects.init();

        setTimeout(()=>{
            expertises.init();
        }, 500)

        initProjectContent();
        app.instanciateSliders();
        app.collapsibles();
        app.collapsibleBox();
        app.toggleComponent();
        app.scrollToTopButton();
        app.showPeopleCV();

        var blogtagparam = sukoaUtils.getParameterByName("filter_tag");
        if(typeof blogtagparam !== "undefined" && blogtagparam !== "") {
            var $tagbar = $(".all-tags");
            var scrolltop = "500px";
            if($tagbar.length>0) {
                scrolltop = $tagbar.offset().top+"px";
            }
            $("body").animate({scrollTop: scrolltop}, 0);
        }

        app.cookiesAlert();
    },

    lazy: function() {
        new Lazy({targets: '.lazy'});

        new Lazy({
            targets: '.lazy-bg',
            loadFn: elt => {
                const imgSrc = elt.getAttribute('data-lazy');
                if(imgSrc) {
                    const img = document.createElement('img');
                    img.onload = () => {
                        elt.style.backgroundImage = 'url("'+imgSrc+'")';
                    }
                    img.src = imgSrc;
                }
            }
        })
    },

    instanciateSliders: function () {
        var sliderwrappers = $(".swiper-container");
        var sliders = [];
        if (sliderwrappers.size() > 0) {
            sliderwrappers.each(function () {
                //put a background color to force Safari to display first slide on page reload
                $(this).find(".swiper-slide").css("background-color", $(this).closest(".bg-slider").css("background-color"));
                sliders.push(new Swiper("#" + $(this).attr("id"), {
                    loop: true,
                    effect: 'slide',
                    spaceBetween: 0,
                    preloadImages: false,
                    lazy: {
                        loadPrevNextAmount: 1
                    },

                    pagination: "#" + $(this).attr("id") + " .pagination",
                    paginationClickable: true,
                    navigation: {
                        nextEl: document.querySelector("#" + $(this).attr("id") + "-button-next"),
                        prevEl: document.querySelector("#" + $(this).attr("id") + "-button-prev")
                    }

                }));
            });
        }
    },

    collapsibles() {
        document.querySelectorAll('.collapsible-button').forEach(btn => {
            let urlParam = btn.getAttribute('data-urlparam');

            if (btn.classList.contains('scrollto')) {
                btn.scrollIntoView({behavior: 'smooth'})
            }

            btn.addEventListener('click', () => {
                history.replaceState(null, null, window.location.origin + window.location.pathname + "?show=" + urlParam);
            })
        });
    },

    collapsibleBox: function () {
        var $collapseButton = $(".collapsible-button");
        if ($collapseButton.size() > 0) {
            $collapseButton.click(function () {

                var wrapperID = $(this).attr("data-open");
                if (typeof wrapperID !== typeof undefined) {
                    var $wrapper = $(wrapperID);
                    var $toOpen = $wrapper.find(".collapsible-content");
                    if ($toOpen.size() > 0) {
                        if($wrapper.hasClass("collapsed")) {
                            $toOpen.slideDown();
                            $wrapper.removeClass("collapsed");
                        } else {
                            $toOpen.slideUp().promise().done(function(){
                                $wrapper.addClass("collapsed");
                            })
                        }
                    }
                }
            });
        }
    },

    toggleComponent: function () {
        var togglewrappers = $(".toggle_wrapper");
        var toggles = [];
        if (togglewrappers.size() > 0) {
            togglewrappers.each(function () {
                var wrapper = $(this);
                $(wrapper).find(".toggle-button").click(function () {
                    var button = $(this);
                    $(wrapper).find(".content_wrapper").slideToggle('slow', function () {
                        if ($(this).is(':visible')) {
                            button.css({"transform":"rotateZ(90deg)"});
                        } else {
                            button.css({"transform":"rotateZ(0deg)"});
                        }
                    });
                });
            })
        }
    },

    scrollToTopButton: function () {
        const $scrollTopBtn = $("#scrollTop");
        const $scrollDownBtn = $("#animation-wrapper .round-button");
        let lastScrollPos = window.scrollY;

        window.addEventListener("scroll", function () {
            const currentScrollPos = window.scrollY;

            if (window.scrollY > 600 &&
                // Show only when scrolling down
                currentScrollPos > lastScrollPos &&
                // Show only when scrollDownBtn exists and is not visible
                ($scrollDownBtn.length === 0 || $scrollDownBtn.hasClass("hide"))
            ) {
                $scrollTopBtn.addClass("active");
            } else {
                $scrollTopBtn.removeClass("active");
            }

            lastScrollPos = currentScrollPos;
        });

        $scrollTopBtn.click(function () {
            if (!$scrollTopBtn.hasClass("atTheTop")) {
                if($("body").hasClass("animation")) {
                    if($("body").attr("id") === "home") {
                        $("body,html").animate({scrollTop: $(window).height()}, 700);

                    } else {
                        $("body,html").animate({scrollTop: 0}, 700);
                    }
                } else {
                    $("body,html").animate({scrollTop: 0}, 700);
                }
            }
        });
    },

    showPeopleCV: function() {

        $("body").on("click", ".peoples.thumbnails .image.has-description", function() {
            $(this).addClass("active");
            var $closebtn = $(this).find(".close");
            var $self = $(this);
            $closebtn.click(function(e){
                e.stopPropagation();
                e.stopPropagation();
                $self.removeClass("active");
                $(this).unbind("click");
            });
        });

        $("body").on("click", ".peoples.list .people.has-description .image, .peoples.list .people.has-description .second", function() {
            var $description = $(this).parent(".people").find(".listdescription");

            if($description.length > 0) {
                $description.slideToggle();
            }
        })
    },



    cookiesAlert: function() {
        if(!sukoaUtils.checkIsEditMode()) {
            var $cookieAlert = $('#cookieAlert');
            if($cookieAlert.length > 0) {
                var $cookies = document.createElement('script');
                $cookies.setAttribute('type', 'text/javascript');
                $cookies.onload = function() {
                    var cookieAccept = Cookies.get('zpf-cookie-accept');
                    if (!cookieAccept || cookieAccept !== 'true') {
                        $cookieAlert.show();
                    }

                    $cookieAlert.click(function () {
                        Cookies.set('zpf-cookie-accept', 'true', {expires: 365});
                        $cookieAlert.fadeOut();
                    });

                    $cookieAlert.on('click', 'a', function(e) {e.stopPropagation();})
                };
                document.getElementsByTagName('head')[0].appendChild($cookies);
                $cookies.src = window.location.contextPath + '/.resources/zpf-module/webresources/js/vendor/jquery.cookie.3.0.24.js';
            }
        }
    }
};
window.sukoaUtils = {dcmadr: sukoaUtils.dcmadr}
document.addEventListener('DOMContentLoaded', () => {
    app.init();
});
